import store from '@/store';
import { isMobileLayout } from '@/utils/mobile-detection';
import MOBILE_PLATFORM_ROUTE_NAMES from './utils/mobilePlatformRoutes';

const MOBILE_PLATFORM_NAV_FLAG = 'rollout.platform_administration.mobile_platform_nav';
const MOBILE_GLASSY_NAV_FLAG = 'rollout.platform_administration.mobile_glassy_nav_layout';

const isMobileView = () => isMobileLayout() || store.getters['CommonStore/isMobileApp'];

const areFeatureFlagsReady = () => store.getters['BusinessStore/featureFlagsLoaded'];

const isMobilePlatformNavigationAvailable = () => {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  return isMobileView()
    && hasFeature(MOBILE_GLASSY_NAV_FLAG)
    && hasFeature(MOBILE_PLATFORM_NAV_FLAG);
};

const redirectUnavailableSessions = (to, from, next) => {
  if (!areFeatureFlagsReady() || isMobilePlatformNavigationAvailable()) {
    next();
    return;
  }

  next({ name: 'dashboard' });
};

const routes = [
  {
    path: '/platform-home',
    name: MOBILE_PLATFORM_ROUTE_NAMES.HOME,
    component: () => import(/* webpackChunkName: "MobilePlatformModuleSelectionPage" */ './views/MobilePlatformModuleSelectionPage.vue'),
    meta: { pageNameEn: 'Platform Home' },
    beforeEnter: redirectUnavailableSessions,
  },
];

export default routes;
